module.exports = __webpack_public_path__ + "img/weibo.23a1d0c9.png";